const columns = {
  creatives: [
    {
      columnValue: (item) => item.creativeCode,
      key: 'creativeCode',
      sortable: true,
      width: 150,
    },
  ],
  lineitems: [
    {
      align: 'start',
      class: 'lineitem-id',
      columnName: 'ID',
      columnValue: (item) => item.id,
      formatAs: null,
      initialSorted: false,
      key: 'id',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'lineitem-name',
      columnName: 'Name',
      columnValue: (item) => item.name,
      formatAs: null,
      initialSorted: true,
      key: 'name',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
  ],
  networks: [
    {
      columnValue: (item) => item.networkCode,
      key: 'networkCode',
      sortable: true,
      width: 150,
    },
  ],
  orders: [
    {
      align: 'start',
      class: 'order-id',
      columnName: 'ID',
      columnValue: (item) => item.id,
      formatAs: null,
      initialSorted: false,
      key: 'id',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-name',
      columnName: 'Name',
      columnValue: (item) => item.name,
      formatAs: null,
      initialSorted: true,
      key: 'name',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-start-date',
      columnName: 'Start Date',
      columnValue: (item) => item.startDateTime,
      formatAs: ['dateObject', 'MM/DD/YYYY'],
      initialSorted: false,
      key: 'startDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-end-date',
      columnName: 'End Date',
      columnValue: (item) => item.endDateTime,
      formatAs: ['dateObject', 'MM/DD/YYYY'],
      initialSorted: false,
      key: 'endDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-unlimited-end-date-time',
      columnName: 'Unlimited End DateTime',
      columnValue: (item) => item.unlimitedEndDateTime,
      formatAs: null,
      initialSorted: true,
      key: 'unlimitedEndDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-last-modified-date-time',
      columnName: 'Last Modified DateTime',
      columnValue: (item) => item.lastModifiedDateTime,
      formatAs: ['dateObject', 'MM/DD/YYYY'],
      initialSorted: true,
      key: 'lastModifiedDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      visible: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-is-archived',
      columnName: 'Archived',
      columnValue: (item) => item.isArchived,
      formatAs: null,
      initialSorted: true,
      key: 'isArchived',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-status',
      columnName: 'Status',
      columnValue: (item) => item.status,
      formatAs: null,
      initialSorted: true,
      key: 'status',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-is-programmatic',
      columnName: 'Programmatic',
      columnValue: (item) => item.isProgrammatic,
      formatAs: null,
      initialSorted: true,
      key: 'isProgrammatic',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-applied-labels',
      columnName: 'Applied Labels',
      columnValue: (item) => item.appliedLabels,
      formatAs: ['join', ', '],
      initialSorted: true,
      key: 'appliedLabels',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-effective-applied-labels',
      columnName: 'Effective Applied Labels',
      columnValue: (item) => item.effectiveAppliedLabels,
      formatAs: ['join', ', '],
      initialSorted: true,
      key: 'effectiveAppliedLabels',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-custom-fields',
      columnName: 'Custom Fields',
      columnValue: (item) => item.customFieldValues,
      formatAs: ['join', ', '],
      initialSorted: true,
      key: 'customFieldValues',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-notes',
      columnName: 'Notes',
      columnValue: (item) => item.notes,
      formatAs: null,
      initialSorted: true,
      key: 'notes',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-total-budget',
      columnName: 'Budget',
      columnValue: (item) => item.totalBudget,
      formatAs: 'microCurrency',
      initialSorted: true,
      key: 'totalBudget',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-clicks',
      columnName: 'Clicks',
      columnValue: (item) => item.totalClicksDelivered,
      formatAs: null,
      initialSorted: true,
      key: 'unlimitedEndDateTime',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-impressions',
      columnName: 'Impressions',
      columnValue: (item) => item.totalImpressionsDelivered,
      formatAs: null,
      initialSorted: true,
      key: 'totalImpressionsDelivered',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-viewable-impressions',
      columnName: 'Viewable Impressions',
      columnValue: (item) => item.totalViewableImpressionsDelivered,
      formatAs: null,
      initialSorted: true,
      key: 'totalViewableImpressionsDelivered',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 150,
    },
  ],
}

export default columns
